import React from 'react';
import { Box, Typography } from '@mui/material';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

interface UnsupportedFileViewProps {
  fileName: string;
}

const UnsupportedFileView: React.FC<UnsupportedFileViewProps> = ({
  fileName,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: '16px',
        color: '#666',
      }}
    >
      <InsertDriveFileOutlinedIcon sx={{ fontSize: '64px', color: '#ccc' }} />
      <Typography variant="h6" sx={{ color: '#666' }}>
        미리보기 미지원 파일
      </Typography>
      <Typography variant="body2" sx={{ color: '#999' }}>
        {fileName}
      </Typography>
    </Box>
  );
};

export default UnsupportedFileView;
